import { render, staticRenderFns } from "./sevenPage.vue?vue&type=template&id=06e0e972&"
import script from "./sevenPage.vue?vue&type=script&lang=js&"
export * from "./sevenPage.vue?vue&type=script&lang=js&"
import style0 from "./sevenPage.vue?vue&type=style&index=0&id=06e0e972&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports